exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-38d8ba96],html[data-v-38d8ba96]{padding:0;margin:0}#donePage[data-v-38d8ba96]{background:var(--theme-color)}", ""]);

// exports
